import React, { Component } from 'react'
import { push, goBack } from 'react-router-redux';
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import shortid from 'shortid'
import { parseString } from 'dxf'
import filesize from 'filesize'

import './DownloadModal.css';

import Button from '../../components/Button/Button.js'
import Tabs from '../../components/Tabs/Tabs.js'
import Pattern from '../../components/Pattern/Pattern.js'
import Checkbox from '../../components/Checkbox/Checkbox.js'

import generateText from '../../pattern_utilities/generateText'

import { setDownloadModalOpen, downloadText, tryToLogDownload } from '../../actions/actions.export.js';


var pf_config = require('../../pf_config.json');

class DownloadModal extends Component {
  static propTypes = {
    dispatch: PropTypes.func.isRequired
  }

  constructor(props){
    super(props);

    this.state = {
      includeData: true,
      includeErrors: true,
      includeHidden: true,
      txtFormat: false
    }

    this.handleCloseModal = this.handleCloseModal.bind(this);
    this.handleDownloadModal = this.handleDownloadModal.bind(this);
  }

  handleCloseModal(){
    const { dispatch } = this.props;

    dispatch(setDownloadModalOpen());
  }

  handleDownloadModal(){
    const { dispatch, patternManager, user, team } = this.props;
    
    if(patternManager.current_pattern !== "local"){
      dispatch(tryToLogDownload({id: patternManager.current_pattern}));
    }

    dispatch(downloadText({
      cacheID: patternManager.current_pattern,
      user: user,
      team: team.current ? team.cache[team.current] : false,
      includeErrors: this.state.includeErrors,
      includeData: this.state.includeData,
      includeHidden: this.state.includeHidden,
      txtFormat: this.state.txtFormat
    }));
    dispatch(setDownloadModalOpen());
  }


  render(){
    const { dispatch, globalReducer, user, team, patternManager } = this.props; 
    
    if(!globalReducer.downloadModalOpen) return "";

    var pattern = patternManager.cache[patternManager.current_pattern];


    var temp_text = generateText(pattern, true, user, team, this.state.includeErrors, this.state.includeData, this.state.includeHidden);

    var bytes = Buffer.byteLength(temp_text, 'utf8');

    var file_size = filesize(bytes);


    var error_count = 0;
    var hidden_count = 0;
    for(var i in pattern.rows){
      error_count += pattern.rows[i].errors.length;

      if(pattern.rows[i].invisible) hidden_count++; 
    }


    return <div className="modal theme-light">
      <div className="modal-bg" onClick={this.handleCloseModal}>
      </div>
      <div className="modal-inner">
        <div className="flex-split">
          <span>
            Download .PAT file
          </span>
          <span>
            <Button size="squared-normal" color="borderless" display={<i className="fal fa-times fa-lg fa-fw"/>} onClick={this.handleCloseModal}/> 
          </span>
        </div>
        <hr/>
        <div className="download-modal">
          <div className="download-preview">
            <Pattern
              hideGUI={true}
              light={true} 
              thumbnail={true}
              cacheID={patternManager.current_pattern} 
              pattern={pattern} 
              errors={true}
              />
          </div>
          <div className="download-modal-info">
            <div className="download-modal-nontable">
              <div className="flex-split">
                <span>
                  Format:
                </span>
                <span className="text-right">
                  <strong>{pattern.format === "REVIT" ? "Revit" : "AutoCAD"}</strong>
                </span>
              </div>

              {
                hidden_count > 0 && 
                <div className="flex-split">
                  <span>
                    Include hidden lines:
                  </span>
                  <span className="download-modal-data td-checkbox">
                    <Checkbox value={this.state.includeHidden} onToggle={(e)=>{ this.setState({includeHidden: !this.state.includeHidden })}}/>
                  </span>
                </div>
              }

              {
                pattern.mode !== 'raster' && 
                <div className="flex-split">
                  <span>
                    Include data for re-importing:
                  </span>
                  <span className="download-modal-data td-checkbox">
                    <Checkbox value={this.state.includeData} onToggle={(e)=>{ this.setState({includeData: !this.state.includeData })}}/>
                  </span>
                </div>
              }

              {
                error_count > 0 && 
                <div className="flex-split">
                  <span>
                    Include Error Info:
                  </span>
                  <span className="download-modal-data td-checkbox">
                    <Checkbox value={this.state.includeErrors} onToggle={(e)=>{ this.setState({includeErrors: !this.state.includeErrors })}}/>
                  </span>
                </div>
              }

              <div className="flex-split">
                <span>
                  Errors
                </span>
                <span className={"download-modal-data " +
                  (error_count == 0 ? "text-success" : "") + 
                  (error_count > 0 ? "text-danger" : "")
                }>
                  <strong>{error_count}</strong>
                </span>
              </div>
              <div className="flex-split">
                <span>
                  Pattern Lines:
                </span>
                <span className="download-modal-data">
                  <strong>{pattern.rows.length}</strong>
                </span>
              </div>

              <div className="flex-split">
                <span>
                  File size: 
                </span>
                <span className="download-modal-data">
                  <strong>{file_size}</strong>
                </span>
              </div>

              <div className="flex-split">
                <span>
                  Use .TXT format instead
                </span>
                <span className="download-modal-data td-checkbox">
                  <Checkbox value={this.state.txtFormat} switch={true} onToggle={(e)=>{ this.setState({txtFormat: !this.state.txtFormat })}}/>
                </span>
              </div>
            </div>
            {
              error_count > 0 ?
              <div className="download-modal-warning">
                <i className="fad fa-exclamation-triangle fa-2x download-modal-warning-icon"></i>
                <span>.PAT file may not import correctly due to lines potentially incompatible with {pattern.format === "REVIT" ? "Revit" : "AutoCAD"}.</span>
              </div>
              :
              <p>
                <br/>
              </p>
            }
            {
              error_count > 0 ? 
              <Button
                display={<span><i className="fad fa-download fa-swap-opacity"/>&nbsp; Download Anyway</span>}
                color="warning"
                size="medium"
                onClick={this.handleDownloadModal}
                /> 
              :
              <Button
                display={<span><i className="fad fa-download fa-swap-opacity"/>&nbsp; Download {this.state.txtFormat ? ".TXT" : ".PAT"} file</span>}
                color="success"
                size="medium"
                onClick={this.handleDownloadModal}
                />
            }
          </div>
        </div>
      </div>
    </div>
    
  }
}
const mapStateToProps = (state) => {
  const { globalReducer, user, team, patternManager } = state;

  return {
    globalReducer, user, team, patternManager
  }
}

export default connect(mapStateToProps)(DownloadModal);



// WEBPACK FOOTER //
// ./src/components/DownloadModal/DownloadModal.js